import axios from "axios";

export const renaveHttp = axios.create({
  baseURL: process.env.REACT_APP_API_RENAVE_URL,
});
